import React from 'react';
import { Form, FormField } from '../../../shared/components/form_components/form';
import { FormGroup } from '../../../shared/components/form_components/group';
import { InputForm } from '../../../shared/components/form_components/input';
import { InputSelect } from '../../../shared/components/form_components/select';
import { InputToggle } from '../../../shared/components/form_components/toggle';
import { CursosPageQuery_unidades } from '../../graphql/queries/__generated__/CursosPageQuery';
import { Container } from './styles';

interface Props {
  curso?: Partial<FormCurso>;
  unidades?: CursosPageQuery_unidades[];
  onSubmit: (curso: FormCurso) => void;
  onCancel?: () => void;
}

interface FormCurso {
  id_curso?: number;
  id_unidade: number;
  dsc_nome_curso: string;
  dsc_sigla_curso: string;
  dsc_nome_apoio: string
  dsc_email_apoio: string
  dsc_telefone_apoio: string
  dsc_ramal_apoio: string
  ativo: boolean;
}

const FormularioCurso: React.FC<Props> = (props) => {
  const fields: FormField[] = [
    {
      name: 'id_curso',
      label: 'Id do curso',
      type: 'number',
      defaultValue: props.curso?.id_curso,
      required: true,
      disabled: true,
      component: InputForm,
    },
    {
      name: 'id_unidade',
      label: 'Id da unidade',
      placeholder: 'Selecione uma unidade',
      type: 'number',
      defaultValue: props.curso?.id_unidade,
      items: props.unidades?.map((u) => ({
        label: u.dsc_nome_unidade || '',
        value: u.id_unidade,
      })),
      required: true,
      readOnly: true,
      component: InputSelect,
    },
    {
      name: 'group_nome_sigla',
      type: 'group',
      sub_fields: [
        {
          name: 'dsc_nome_curso',
          label: 'Nome do curso',
          type: 'text',
          defaultValue: props.curso?.dsc_nome_curso,
          required: true,
          component: InputForm,
        },
        {
          name: 'dsc_sigla_curso',
          label: 'Sigla do curso',
          type: 'text',
          defaultValue: props.curso?.dsc_sigla_curso,
          required: true,
          component: InputForm,
        },
        {
          name: 'ativo',
          label: 'Ativo',
          id: 'curso_ativo',
          type: 'checkbox',
          defaultChecked: props.curso?.ativo,
          required: true,
          component: InputToggle,
        },
      ],
      component: FormGroup,
    },
    {
      name: 'group_apoio',
      type: 'group',
      sub_fields: [
        {
          name: 'dsc_nome_apoio',
          label: 'Nome do apoio',
          type: 'text',
          defaultValue: props.curso?.dsc_nome_apoio,
          required: false,
          component: InputForm,
        },
        {
          name: 'dsc_email_apoio',
          label: 'E-mail do apoio',
          type: 'text',
          defaultValue: props.curso?.dsc_email_apoio,
          required: false,
          component: InputForm,
        },
        {
          name: 'dsc_telefone_apoio',
          label: 'Telefone do apoio',
          type: 'text',
          defaultValue: props.curso?.dsc_telefone_apoio,
          required: false,
          component: InputForm,
        },
        {
          name: 'dsc_ramal_apoio',
          label: 'Ramal do apoio',
          type: 'text',
          defaultValue: props.curso?.dsc_ramal_apoio,
          required: false,
          component: InputForm,
        }
      ],
      component: FormGroup,
    },
  ];

  return (
    <Container>
      <Form
        fields={fields}
        form_name='curso'
        is_edit={Boolean(props.curso?.id_curso)}
        onSubmit={props.onSubmit}
        onCancel={props.onCancel}
      />
    </Container>
  );
};

export { FormularioCurso };
export type { FormCurso };
